// extracted by mini-css-extract-plugin
module.exports = {"root":"_1h0E_","subtitle":"qGiMW"};